import React, { Component }         from 'react';
import PropTypes                    from 'prop-types';
import { Segment, Header } from 'semantic-ui-react';

import connectResource      from 'utils/connectResource';
import { getSingleton }     from 'utils/connectors';
import { versions }         from 'resources/organizationResources';
import formattedDate        from 'utils/formattedDate';

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

class Versions extends Component {
  render() {
    const { data: { summary={} }, loading } = this.props;

    const {created_by, created_at, updated_by, updated_at } = summary || {};

    return (
      <Segment loading={ loading }>
        <Header as="h3" dividing>Record Summary</Header>
          { created_by &&
          <div>Created by: { created_by }</div>
          }

          { created_at &&
          <div>Created at: { formattedDate(created_at) }</div>
          }

          { updated_by &&
          <div>Updated by: { updated_by }</div>
          }

          { updated_at &&
          <div>Updated at: { formattedDate(updated_at) }</div>
          }
      </Segment>
    );
  }
}

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

Versions.defaultProps = {
  loading: false
};

Versions.propTypes = {
  recordId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,

  recordType: PropTypes.string.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default connectResource(Versions, {
  key: ({ recordType, recordId }) => [recordType, recordId ].join('_'),
  connectors: {
    summary: getSingleton(versions, ({ recordType, recordId }) => ({
      record_type: recordType,
      record_id:   recordId
    }))
  },
});
